export function ValidationErrorTooltip({ message }: { message: string | null }) {
  if (!message) return null;

  return (
    <p
      role="alert"
      className="absolute left-0 top-full z-30 mt-2 w-full rounded-lg border border-red-500/80 bg-red-950/90 px-3 py-2 text-sm leading-snug text-red-100 shadow-xl"
    >
      <span
        className="absolute -top-2 left-6 h-4 w-4 rotate-45 border-l border-t border-red-500/80 bg-red-950/90"
        aria-hidden
      />
      <span className="relative z-10 block">{message}</span>
    </p>
  );
}
